export default {
  pt: {
    Sidebar: {
      soonTooltip: 'Em Breve!',
      dashboard: 'Dashboard Geral',
      dashboardTasks: 'Dashboard Tarefas',
      dashboardContributors: 'Dashboard Colaboradores',
      dashboardCustomers: 'Dashboard Clientes',
      taskTitle: 'Tarefas',
      taskSchedule: 'Agenda',
      taskList: 'Lista Tarefas',
      taskKanban: 'Kanban Tarefas',
      taskType: 'Tipos de Tarefa',
      forms: 'Formularios',
      taskBreakReasons: 'Motivos de Pausa',
      collaboratorsTitle: 'Colaboradores',
      collaboratorsList: 'Lista Colaboradores',
      collaboratorsTeams: 'Equipes',
      collaboratorsSkills: 'Habilidades',
      collaboratorsScales: 'Escalas',
      collaboratorsStatus: 'Status',
      clientsTitle: 'Clientes',
      clientsList: 'Lista Clientes',
      clientsParent: 'Cliente Principal',
      clientsContacts: 'Contatos',
      clientsSegments: 'Segmentos',
      equipmentsTitle: 'Equipamentos',
      equipmentsList: 'Lista Equipamentos',
      equipmentsCategories: 'Categorias',
      equipmentsTemplates: 'Templates de Especificaçao',
      reportsTitle: 'Relatórios',
      reportsTasksTitle: 'Tarefas',
      reportsTasks: 'Tarefas',
      reportsKmTitle: 'Km rodados',
      reportsKm: 'Km Percorrido',
      settingsTitle: 'Configurações',
      settingsSubTitle: 'Usuários Web',
      settingsLogin: 'Login de acesso',
      settingsPermissions: 'Permissões',
      financialTitle: 'Financeiro',
      financialAgreed: 'Valores acordados',
      financialReceive: 'Valores a receber',
      financialAmount: 'Valores a pagar',
      solicitationType: 'Tipos de solicitação',
      helpdesk: 'Solicitações de Clientes',
      bdMaintenanceTitle: 'Bancos de dados',
      maintenance: 'Manutenção',
      systems: 'Sistemas',
      activity: 'Atividades',
      badgeTitle: 'Crachá',
    },
  },
  en: {
    Sidebar: {
      soonTooltip: 'Shortly!',
      dashboard: 'Dashboard',
      dashboardTasks: 'Dashboard Tasks',
      dashboardContributors: 'Dashboard Contributors',
      dashboardCustomers: 'Dashboard Customers',
      taskTitle: 'Tasks',
      taskSchedule: 'Schedule',
      taskList: 'Task List',
      taskKanban: 'Kanban Tasks',
      taskType: 'Task Types',
      forms: 'Forms',
      taskBreakReasons: 'Break Reasons',
      collaboratorsTitle: 'Collaborators',
      collaboratorsList: 'List of Collaborators',
      collaboratorsTeams: 'Teams',
      collaboratorsSkills: 'Skills',
      collaboratorsScales: 'Scales',
      collaboratorsStatus: 'Status',
      clientsTitle: 'Customers',
      clientsList: 'Customer List',
      clientsParent: 'Customer Principal',
      clientsContacts: 'Contacts',
      clientsSegments: 'Segments',
      equipmentsTitle: 'Equipment',
      equipmentsList: 'Equipment List',
      equipmentsCategories: 'Categories',
      equipmentsTemplates: 'Specification Templates',
      reportsTitle: 'Reports',
      reportsTasksTitle: 'Tasks',
      reportsTasks: 'Tasks',
      reportsKmTitle: 'Km traveled',
      reportsKm: 'Km Traveled',
      settingsTitle: 'Settings',
      settingsSubTitle: 'Web Users',
      settingsLogin: 'Access Login',
      settingsPermissions: 'Permissions',
      financialTitle: 'Financial',
      financialAgreed: 'Agreed values',
      financialReceive: 'Amounts receivable',
      financialAmount: 'Amounts to pay',
      solicitationType: 'Request types',
      helpdesk: 'Customer Requests',
      bdMaintenanceTitle: 'Databases',
      maintenance: 'Maintenance',
      systems: 'Systems',
      activity: 'Activities',
      badgeTitle: 'Badge',
    },
  },
  es: {
    Sidebar: {
      soonTooltip: '¡Dentro de poco!',
      dashboard: 'Dashboard',
      dashboardTasks: 'Panel de Tareas',
      dashboardContributors: 'Panel de Colaboradores',
      dashboardCustomers: 'Panel de Clientes',
      taskTitle: 'Tareas',
      taskSchedule: 'Calendario',
      taskList: 'Lista de tareas',
      taskKanban: 'Tareas Kanban',
      taskType: 'Tipos de tareas',
      forms: 'Formularios',
      taskBreakReasons: 'Romper Razones',
      collaboratorsTitle: 'Colaboradores',
      collaboratorsList: 'Lista de Colaboradores',
      collaboratorsTeams: 'Equipos',
      collaboratorsSkills: 'Habilidades',
      collaboratorsScales: 'Escamas',
      collaboratorsStatus: 'Estado',
      clientsTitle: 'Clientes',
      clientsList: 'Lista de clientes',
      clientsParent: 'Cliente Principal',
      clientsContacts: 'Contactos',
      clientsSegments: 'Segmentos',
      equipmentsTitle: 'Equipo',
      equipmentsList: 'Lista de equipo',
      equipmentsCategories: 'Categorías',
      equipmentsTemplates: 'Plantillas de especificaciones',
      reportsTitle: 'Informes',
      reportsTasksTitle: 'Tareas',
      reportsTasks: 'Tareas',
      reportsKmTitle: 'Km Recorridos',
      reportsKm: 'Km Recorridos',
      settingsTitle: 'Ajustes',
      settingsSubTitle: 'Usuarios Web',
      settingsLogin: 'Acceso inicio de sesión',
      settingsPermissions: 'Permisos',
      financialTitle: 'Financiero',
      financialAgreed: 'Valores acordados',
      financialReceive: 'Montos por cobrar',
      financialAmount: 'Montos a pagar',
      solicitationType: 'Tipos de solicitud',
      helpdesk: 'Solicitudes de Clientes',
      bdMaintenanceTitle: 'Bases de datos',
      maintenance: 'Mantenimiento',
      systems: 'Sistemas',
      activity: 'Actividades',
      badgeTitle: 'Insignia',
    },
  },
}
